export class ApiError<R = any> {
  constructor(
    public readonly statusCode?: number,
    public readonly message?: string,
    public readonly response?: R,
  ) {}
}
